import { z } from "zod";

/* Addresses are used in the Buildings schema */

export const addressSchema = z.object({
  street: z.string(),
  house_number: z.number().nullable(),
  house_letter: z.string(),
  house_number_suffix: z.string(),
  postalcode: z.string().nullable(),
  city: z.string() /* Name of an administrative boundary */,
});

export type Address = z.infer<typeof addressSchema>;
